import { render } from "./currentuser.vue?vue&type=template&id=289e7b6b&scoped=true"
import script from "./currentuser.vue?vue&type=script&lang=js"
export * from "./currentuser.vue?vue&type=script&lang=js"

import "./currentuser.vue?vue&type=style&index=0&id=289e7b6b&scoped=true&lang=scss"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289e7b6b"]])

export default __exports__